import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'SCHOOL'

export type SchoolsState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function schoolsReducer(state: SchoolsState = initialState, action: AnyAction): SchoolsState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
